import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import LayoutForm from "./LayoutForm";
import PublicLayouts from "./PublicLayouts";
import Groups from "./Groups";
import { t } from "i18next";

export default function Index(props) {
  let [tab, setTab] = useState(0);
  let [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  const handleResize = () => {
    setScreenHeight(window.innerHeight);
  };

  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Dialog
      sx={{ marginTop: "40px" }}
      open={props.open}
      onClose={props.handleCloseMsg}
      fullWidth
      maxWidth={"md"}
    >
      <DialogContent
        sx={{ overflowX: "auto", minHeight: screenHeight - 197 + "px" }}
      >
        <Box>
          <Tabs
            value={tab}
            onChange={handleChangeTab}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTabs-flexContainer": {
                alignItems: "center",
              },
              "& .MuiTab-root:last-of-type": {
                marginLeft: "auto",
              },
            }}
          >
            <Tab label={t("myLayouts")} />
            <Tab label={t("groups")} />
            <Tab label={t("layoutLibrary")} />
          </Tabs>
        </Box>

        <DialogContentText>
          {tab === 0 && <LayoutForm />}
          {tab === 1 && <Groups />}
          {tab === 2 && <PublicLayouts />}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ display: "flex", textAlign: "left" }}>
        {props.children}
      </DialogActions>
    </Dialog>
  );
}
